//we'll store this to know if we've already processed translations
var translations_processed = false; // Function to handle the translation logic

function handleTranslations() {
  //attempt to find a weglot country selector
  var weglot_selector = document.querySelector('.weglot-inline.country-selector'); //if we have a selector...

  if (weglot_selector) {
    //grab our current API URL (this remains fixed regardless of weglot translation strings so becomes a good reference point)
    var api_url = document.querySelector('link[rel="https://api.w.org/"]') ? document.querySelector('link[rel="https://api.w.org/"]').href.replace('/wp-json', '').replace(/^\/|\/$/g, '') : false; //try to find our language choice

    var weglot_choice = weglot_selector.querySelector('.wgcurrent') ? weglot_selector.querySelector('.wgcurrent').getAttribute('data-l') : false; //if we have a valid URL and a language choice that isn't already the default language...

    if (api_url && weglot_choice && api_url.includes('/' + weglot_choice) === false) {
      //fetch all a tags on the page
      var a_tags = document.getElementsByTagName('a'); //if we have some a tags to loop through

      if (a_tags && a_tags.length > 0) {
        //log how many replacements we've made
        var counter = 0; //check if the api URL contains www. already, if it doesn't add it

        var www_url = api_url.includes('www.') ? api_url : api_url.replace('https://', 'https://www.'); //check if the api URL contains www. already, if it does remove it

        var non_www_url = api_url.includes('www.') ? api_url.replace('www.', '') : api_url; //loop over them...

        for (var i = 0; i < a_tags.length; i++) {
          var _a_tags$i$getAttribut;

          //fetch our href
          var href = (_a_tags$i$getAttribut = a_tags[i].getAttribute('href')) !== null && _a_tags$i$getAttribut !== void 0 ? _a_tags$i$getAttribut : false; //check to see if this is a weglot language link (we need to leave these alone)

          var weglot_link = a_tags[i].getAttribute('class') ? a_tags[i].getAttribute('class').includes('weglot-language') : false;

          for (var ii = 0; ii < 2; ii++) {
            var target_url = ii == 0 ? www_url : non_www_url; //if the href contains our API URL and doesn't already contain our language choice or wp-admin or wp-content...

            if (href && weglot_link == false && href.includes(target_url) && !href.includes(target_url + '/' + weglot_choice) && !href.includes('/wp-admin') && !href.includes('/wp-content')) {
              //replace the API URL with the API URL and our language choice
              href = href.replace(target_url, target_url + '/' + weglot_choice); //update the href

              a_tags[i].href = href; //increment our counter

              counter++;
            }
          }
        } //if we haven't processed translations yet or we have and we've made at least one replacement...


        if (!translations_processed || translations_processed && counter > 0) {
          //log how many replacements we've made
          console.info('Replaced ' + counter + (translations_processed ? ' more' : '') + ' links with ' + weglot_choice + ' language choice');
        } //indicate we've performed at least one translation


        translations_processed = true;
      }
    }
  }
} //wait for our document to be ready


document.addEventListener('DOMContentLoaded', function () {
  //check to see if we've enabled our helper JS
  var weglot_helper = document.body.getAttribute('data-weglot_helper') ? true : false; //if the helper is enabled...

  if (weglot_helper) {
    //run the function immediately
    handleTranslations(); //set interval to run the function every second

    setInterval(handleTranslations, 1000);
  }
});